export default __webpack_public_path__ + "static/media/Baskerville-Regular.1caed547.woff2";